import React, { useState } from 'react';
import { getVerticalOffsetForOverlay } from './getVerticalOffset';
import AnchoredModal from '@components/Shared/Modal/AnchoredModal/AnchoredModal';
import ItemPicker from '@components/Shared/ItemPicker';
import {
  bathItems,
  bedItems,
  DEFAULT_BATHS,
  DEFAULT_BEDS,
} from '@utils/homeSearchConstants';

type Props = {
  baths: number;
  beds: number;
  onApplyClick: (updatedBedsBaths: { beds: number; baths: number }) => void;
  onCloseClick: () => void;
};

const FilterBedsBaths = ({
  beds,
  baths,
  onApplyClick,
  onCloseClick,
}: Props): JSX.Element => {
  const [filterBeds, setFilterBeds] = useState(beds);
  const [filterBaths, setFilterBaths] = useState(baths);

  return (
    <AnchoredModal
      automationId="filters-beds-baths"
      applyButtonClassName="filters-beds-baths-apply-button"
      clearButtonClassName="filters-clear-button"
      onApplyButtonClick={() => {
        if (beds === filterBeds && baths === filterBaths) {
          onCloseClick();
        } else {
          onApplyClick({
            beds: filterBeds,
            baths: filterBaths,
          });
        }
      }}
      onClearButtonClick={() => {
        if (beds === DEFAULT_BEDS && baths === DEFAULT_BATHS) {
          onCloseClick();
        } else {
          onApplyClick({
            beds: DEFAULT_BEDS,
            baths: DEFAULT_BATHS,
          });
        }
      }}
      onCloseClick={onCloseClick}
      pageOverlayVerticalOffsetInPixels={getVerticalOffsetForOverlay()}
    >
      <div>
        <div>
          <h4>Beds</h4>
          <div>
            <ItemPicker
              id="beds"
              items={bedItems}
              selectedValue={filterBeds.toString()}
              onChange={({ value }) => setFilterBeds(value)}
            />
          </div>
        </div>

        <div className="mb-5 pt-3">
          <h4>Baths</h4>
          <div>
            <ItemPicker
              id="baths"
              items={bathItems}
              selectedValue={filterBaths.toString()}
              onChange={({ value }) => setFilterBaths(value)}
            />
          </div>
        </div>
      </div>
    </AnchoredModal>
  );
};

export default FilterBedsBaths;
